import { Chicken } from '../types/Chicken';
import { ChickenSvg } from './ChickenSvg';

export const ChickenProfileItem = ({chicken, image_url, annotation_value, user_id}: {chicken: Chicken, image_url: string, annotation_value: bool, user_id: integer}) => {
  return (
    <>
      <div className="card lg:card-side bg-base-100 shadow-sm max-w-4xl mx-auto mb-15">
        <figure>
          <img src={image_url} className="max-w-xl" alt={ "Rooster named " + chicken.attributes.name } />
        </figure>
        <div className="card-body text-black text-left">
          <h2 className="card-title">Name: { chicken.attributes.name }</h2>
          <div className="card-actions">Nickname: <p class="font-normal">{ chicken.attributes.value }</p></div>
          <div className="card-actions">First seen: <p class="font-normal">{ chicken.attributes.chicken_created_at }</p></div>
          <div className="card-actions">This sighting: <p class="font-normal">{ chicken.attributes.created_at }</p></div>
          {user_id == chicken.attributes.user_id ? (<ChickenSvg className="max-h-5 max-w-5" />) : ''}
        </div>
      </div>
    </>
  );
};
